export default "__VITE_ASSET__5deea555__"